<template>
  <div>
    <blocInfoPointDV/>
    <CartoGeneral class="mt-20"/>
    <listesPanneau class="mt-20"/>
  </div>
</template>

<script>
import BlocInfoPointDV from './blocProduits/BlocInfoPointDVente';
import CartoGeneral from './CartoGeneral';
import ListesPanneau from './blocProduits/ListesPanneau';

export default {
  components: {
    BlocInfoPointDV,
    CartoGeneral,
    ListesPanneau,
  },
  data: () => ({
  }),
  computed: {
  },
  methods: {
  },
}
</script>

<style>

</style>